export default "__VITE_ASSET__Dkmuj9Sb__"